<template>
  <reach-input
      placeholder="Choose color"
      :formField="validatedField"
      :field-config="fieldConfig"
      :label="fieldConfig.fieldLabel"
      :read-only="readOnly || !validatedField || validatedField.readOnly"
      :editor-mode="editorMode"
      :hint="fieldConfig.shortHelpText"
      :help-title="fieldConfig.helpWindowTitle"
      :help-message="fieldConfig.htmlHelpText"
      :grid-editor="gridEditor"
  >
    <template slot="left-slot">
      <input :disabled="readOnly" type="color" v-model="colorText" style="height: 38px; width: 38px">
    </template>
  </reach-input>
</template>

<script>
import ReachInput from "@/components/inputs/ReachInput";
import FormValidatedField from "@/components/forms/FormValidatedField";
import ColorPickerFormFieldConfig
  from "@/server/com/silkplm/engine/forms/schema/definition/ColorPickerFormFieldConfig";
import InputBase from "@/components/inputs/InputBase";

export default {
  components: {InputBase, ReachInput},
  name: "ColorPickerRenderer",

  async mounted() {
    await this.valChange(this.validatedField.value);
  },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    setEditorMode(val) {
      this.editorMode = val;
    },

    async valChange(val) {
      if (this.updateInProgress) {
        return;
      }
      this.updateInProgress = true;
      try {
        let res = /^#([a-fA-F0-9]{6})$/.test(val);
        if (res) {
          this.colorText = val;
        }
      } finally {
        this.updateInProgress = false;
      }
    }
  },

  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: ColorPickerFormFieldConfig, required: true},
    openFromGrid: {default: false},
    gridEditor: {default: null},
    mode: {default: null},
  },

  watch: {
    "validatedField.value": async function (val) {
      await this.valChange(val);
    },

    "validatedField": async function (val) {
      await this.valChange(val.value);
    },

    "colorText": async function (newVal, oldVal) {
      if (this.updateInProgress) {
        return;
      }
      this.updateInProgress = true;
      try {
        let res = /^#([a-fA-F0-9]{6})$/.test(newVal);
        if (res) {
          this.colorText = newVal;
        } else {
          this.colorText = oldVal;
        }
        this.validatedField.value = this.colorText;
      } finally {
        this.updateInProgress = false;
      }
    },

  },

  data: () => ({
    colorText: "#000000",
    updateInProgress: false,
    readOnly: true,
    editorMode: false,
  })
}
</script>
